export default __webpack_public_path__ + "static/hero-content-bg-dcc13eda3e382d107252bffffbfeedc6.svg";